// CommonTabs.js
import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

const CommonTabs = ({ tabs,active }) => {
  const [activeTab, setActiveTab] = useState(active ? active : tabs[0].key);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div>
      <Nav tabs>
        {tabs.map(({ key, title }) => (
          <NavItem key={key}>
            <NavLink
              className={activeTab === key ? 'active' : ''}
              onClick={() => toggleTab(key)}
            >
              {title}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab}>
        {tabs.map(({ key, content }) => (
          <TabPane key={key} tabId={key}>
            {content}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};

export default CommonTabs;
